// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__cEgTW","emails":"CreateEditClinics_emails__1QnuL","emailTagLabel":"CreateEditClinics_emailTagLabel__OsrBN"};